<script>
  import YellowButton from '@/components/base/YellowButton.vue';

  export default {
    name: 'RedemptionRequirements',
    components: { YellowButton },

    props: {
      value: {
        required: true,
      },
    },

    data: () => ({
      showDialog: false,
    }),

    watch: {
      value: {
        immediate: true,
        handler(value) {
          this.showDialog = value;
        },
      },
    },

    methods: {
      closeDialog() {
        this.showDialog = false;

        this.$emit('input', false);
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    max-width="850px"
    content-class="confirm-dialog alert-shadow rounded-borders-5 overflow-x-hidden"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @click:outside="closeDialog()"
    @keydown.esc="closeDialog()"
  >
    <v-card class="d-flex flex-column justify-center align-center position-relative py-6">
      <v-icon size="36" color="white" @click="closeDialog">mdi-close</v-icon>

      <v-card-title class="justify-center px-5 mb-9">
        <span class="white--text font-size-28 font-weight-bold text-h3 redemption-title">REDEMPTION REQUIREMENTS</span>
      </v-card-title>

      <v-card-text class="white--text text-center font-size-20 font-weight-semi">
        <div class="requirements-container">
          <div class="gold--text font-weight-600 body-1">1. Playtrough Requirement</div>
          <p class="font-weight-500 mb-2">
            All funds must be played in games at least once before they are eligible for withdrawal.
          </p>
          <p class="font-weight-500">
            This includes any bonus credits or winnings credited to your account. Bonus credits may have different
            playthrough.
          </p>

          <div class="gold--text font-weight-600 body-1 mt-6">2. Funds Eligible for Withdrawal</div>
          <ul class="mb-6">
            <li>
              Funds used in games and any winnings from contests, including FastPlay and Player vs Player, are eligible
              for withdrawal.
            </li>
            <li>
              Funds that have not been played in games are not eligible for withdrawal and must first meet the
              playthrough requirement.
            </li>
          </ul>

          <div class="gold--text font-weight-600 body-1">3. Withdrawal Process</div>
          <strong class="mt-3 d-block">
            To withdraw your funds, the following steps and requirements must be met:
          </strong>
          <ol class="ml-4 mt-2">
            <li>
              <strong>Eligibility Requirements:</strong>
              <ul>
                <li>All funds must be played at least once in games to become eligible for withdrawal.</li>
                <li>A minimum balance of $10 is required to initiate a withdrawal request.</li>
              </ul>
            </li>
            <li>
              <strong>Withdrawal Steps:</strong>
              <ul>
                <li>Select your withdrawal method.</li>
                <li>Enter your payment details, such as your bank account or payment wallet information</li>
                <li>Submit your withdrawal request.</li>
              </ul>
            </li>
            <li>
              <strong>Processing Time:</strong>
              <ul>
                <li>Allow up to 48 hours for larger withdrawal requests.</li>
                <li>If verification is required, promptly complete the process to avoid delays.</li>
              </ul>
            </li>
            <li>
              <strong>Important Notes:</strong>
              <ul>
                <li>Updating your payment details will require additional verification and security checks.</li>
              </ul>
            </li>
          </ol>
        </div>
      </v-card-text>

      <v-card-actions>
        <YellowButton @click="closeDialog">CLOSE</YellowButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
  .gold--text {
    font-size: 18px !important;
  }
  p {
    line-height: 120%;
  }
  ol > li {
    margin-top: 12px;
    strong {
      font-size: 18px;
    }
  }
  ul {
    list-style-type: disc;

    li {
      line-height: 24px;
      margin-top: 4px;
      font-weight: 400;
      font-size: 16px;
    }
  }

  .redemption-title {
    text-shadow: 12px 12px 30px rgba(0, 0, 0, 0.5);
    word-break: auto-phrase;
  }

  .requirements-container {
    background: var(--v-main-crisp-base);
    border-radius: 10px;
    max-height: 400px;
    overflow-y: auto;
    text-align: left;
    padding: 20px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 0.5px;
      width: 100%;
      background: linear-gradient(to right, transparent, white, transparent);
    }

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background: var(--v-main-base);
    }

    &::-webkit-scrollbar-thumb {
      background-color: white;
      border-radius: 10px;
      border: 3px solid transparent;
    }
  }

  .confirm-dialog {
    .v-card {
      background: rgb(67, 37, 89);
      background: linear-gradient(-35deg, rgba(67, 37, 89, 1) 27%, rgba(135, 121, 182, 1) 100%);

      .v-icon {
        position: absolute;
        right: 15px;
        top: 10px;
      }

      .v-card__actions {
        gap: 25px;
      }

      .v-btn {
        width: 150px;
        border-radius: 10px;
        color: white;
      }
    }
  }
</style>
